import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28e73409")

_pushScopeId("data-v-28e73409")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název tipu a triku", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = {
  key: 1,
  class: "title"
}
const _hoisted_8 = { class: "discount column-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Jazyky", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "discount column-3"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "discount column-4"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "discount-line"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "discount column-1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název", -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "discount-line"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = { class: "discount column-1" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Obrázek", -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_30 = { class: "discount column-2" }
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Obsah", -1)
const _hoisted_32 = { class: "value" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.faq.title), 1),
        _hoisted_5,
        (_ctx.visible === false)
          ? (_openBlock(), _createBlock("p", _hoisted_6, [
              _createVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                class: "faq-detail"
              }, "Více informací")
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("p", _hoisted_7, [
              _createVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                class: "faq-detail"
              }, "Méně informací")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.getLanguages().toString().toUpperCase()), 1),
        _hoisted_11
      ]),
      (_ctx.isRearranging === false)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("button", {
              class: "button-edit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editFaq(_ctx.faq)))
            }, "Upravit"),
            _hoisted_13,
            _createVNode("button", {
              class: "button-delete",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeFaq(_ctx.faq)))
            }, "Smazat"),
            _hoisted_14
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRearranging === true)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode("button", {
              class: "button",
              disabled: _ctx.faq.order === 1,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moveFaq(_ctx.faq, -1)))
            }, "Up", 8, ["disabled"]),
            _hoisted_16,
            _createVNode("button", {
              class: "button",
              disabled: _ctx.faq.order === _ctx.listLength,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveFaq(_ctx.faq, 1)))
            }, "Down", 8, ["disabled"]),
            _hoisted_17
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getFaqTranslates(), (translate) => {
      return (_openBlock(), _createBlock("div", { key: translate }, [
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode("p", _hoisted_22, _toDisplayString(translate.page_title), 1),
                _hoisted_23
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visible === true)
          ? (_openBlock(), _createBlock("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode("p", _hoisted_28, _toDisplayString(translate.page_image_url), 1),
                _hoisted_29
              ]),
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode("p", _hoisted_32, _toDisplayString(translate.page_content_url), 1),
                _hoisted_33
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _hoisted_34,
    _hoisted_35
  ], 64))
})